import React from "react";
import { connect } from "react-redux";
import Moment from "moment";
import { changeSubMenu, getListadoSubMedidasPorPlanMovilidad } from "../actions";
import { compareTwoDates } from "../functions";
import Loading from "../../Util/Loading";

class RoadMapSeguimientoPlanMovilidad extends React.PureComponent {
  constructor(props) {
    super(props);
    // voy a buscar la información
    this.props.dispatch(getListadoSubMedidasPorPlanMovilidad(this.props.idplanMovilidad));
    this.state = {
      leftRange: null,
      rightRange: null,
      months: [],
      height: null,
      load: false,
    };
  }

  componentDidUpdate = () => {
    if (this.props.subMedidasPlanesMovilidad.length > 0 && this.props.isSubMedidasLoading && !this.state.load) {
      this.setState(this.calculateRangeDate(this.props.subMedidasPlanesMovilidad));


      // tengo que calcular el tamaño por la cantidad de sumedidas en el plano
      const varSize = (this.props.subMedidasPlanesMovilidad.length * 68) + 20;

      this.setState({
        load: true,
        height: varSize,
        boxSize: `0 0 1301 ${varSize + 70}`,
      });
    }
  }
  getSubMedidaInfo = (submedida, id, left) => {
    // defino mi rango menor
    let auxLeft = new Date(left);
    auxLeft = auxLeft.setDate(1);
    const minRange = Moment(auxLeft);

    // defino los rangos de pintado
    const ini = Moment(submedida.fechaInicio);
    const end = Moment(submedida.fechaLimite);

    let estado = "";
    let color = "";
    switch (submedida.estadoSubMedida) {
      case 1:
        estado = "Finalizado";
        color = "#00A4B2";
        break;
      case 2:
        estado = "En ejecución";
        color = "#00B2A9";
        break;
      default:
        estado = "En construcción";
        color = "#E6FFFE";
    }
    return {
      //estado,
      color,
      translate: `translate(${314 + (ini.diff(minRange, "days") * 3)}.000000, ${811 + (70 * id)}.000000)`,
      width: (end.diff(ini, "days") * 3) + 1,
    };
  }

  // retorna la función que calcula la posición de X en el mapa
  getToday = (minDate) => {
    const today = Moment();
    let aux = new Date(minDate);
    aux = aux.setDate(1);
    const before = Moment(aux);
    return `translate(${276 + (today.diff(before, "days") * 3)}.000000, 810.000000)`;
  }

  getSplitDescription = (descripcion) => {
    let up = [];
    let down = [];
    for (let i = 0; i < 31; i++) {
      up = up.concat(descripcion[i]);
    }
    if (descripcion.length > 31) {
      up = up.concat("-");
    }
    for (let i = 31; i < 61; i++) {
      down = down.concat(descripcion[i]);
    }
    if (descripcion.length > 61) {
      down = down.concat("...");
    }
    return { first: up.join(""), second: down.join("") };
  }

  whereEnero = (months) => {
    for (let i = 0; i < months.length; i++) {
      if (months[i] === "ENE") {
        return i;
      }
    }
    return -1;
  }

  // retorna nuevo arreglo de meses arreglado.
  createMonth = (month) => {
    const meses = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
    let mesesAux = [];
    const fm = new Date(month).getMonth();

    // completo meses desde el que estoy hasta DIC
    for (let i = fm; i < meses.length; i++) {
      mesesAux = mesesAux.concat(meses[i]);
    }
    // completo con los meses desde ENE hasta el que estoy
    for (let i = 0; i < fm; i++) {
      mesesAux = mesesAux.concat(meses[i]);
    }
    return mesesAux;
  }

  calculateRangeDate = (medidas) => {
    let left = medidas[0].fechaInicio;
    let right = medidas[0].fechaLimite;
    for (let i = 1; i < medidas.length; i++) {
      if (compareTwoDates(left, medidas[i].fechaInicio) > 0) {
        left = medidas[i].fechaInicio;
      }
      if (compareTwoDates(right, medidas[i].fechaLimite) < 1) {
        right = medidas[i].fechaLimite;
      }
    }
    return {
      leftRange: left,
      rightRange: right,
      months: this.createMonth(left),
      year: new Date(left).getFullYear(),
    };
  }

  render() {
    if ((this.props.isSubMedidasLoading || !this.state.load)) {
      return (<Loading />);
    }
    return (
      <section id="roadmap-planmovilidad">
        <div className="row">
          <div className="col-md-10 PM-tipo-denuncias-select">
            <div className="PM-section-title PM-title">Roadmap</div>
          </div>
          <div className="col-md-2 PM-botones-top">
            <button className="btn PM-dx-button-plan PM-dx-button-plan-100" onClick={() => { this.props.dispatch(changeSubMenu(1)); }} >Volver</button>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <svg width="100%" height="100%" viewBox={this.state.boxSize} version="1.1" xmlns="http://www.w3.org/2000/svg">
              <defs></defs>
              <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="etapa-4---roadmap" transform="translate(-108.000000, -759.000000)">
                  <rect id="Rectangle" stroke="#D4E1F4" x="313.5" y="810.5" width="1095" height={this.state.height - 23}></rect>
                  <g id="Group-7" transform="translate(313.000000, 750.000000)">

                    <text id="2019" fontFamily="Catamaran" fontSize="18" fontWeight="bold" fill="#00B2A9">
                      <tspan x="0" y="20">{this.state.year}</tspan>
                    </text>
                    {/* Necesito saber en que posición está enero */}
                    <text id="2020" fontFamily="Catamaran" fontSize="18" fontWeight="bold" fill="#00B2A9">
                      <tspan x={this.whereEnero(this.state.months) * 92} y="20">{this.state.year + 1}</tspan>
                    </text>

                    {this.state.months.map((m, k) => (
                      <text key={k} id={m} fontFamily="Catamaran" fontSize="14" fontWeight="500" fill="#00B2A9">
                        <tspan x={k * 92} y="45">{m}</tspan>
                      </text>
                    ))}
                    <rect id="Rectangle" fill="#D4E1F4" x="92" y="60" width="1" height={this.state.height - 23}></rect>
                    <rect id="Rectangle-Copy-8" fill="#D4E1F4" x="184" y="60" width="1" height={this.state.height - 23}></rect>
                    <rect id="Rectangle-Copy-13" fill="#D4E1F4" x="276" y="60" width="1" height={this.state.height - 23}></rect>
                    <rect id="Rectangle-Copy-14" fill="#D4E1F4" x="368" y="60" width="1" height={this.state.height - 23}></rect>
                    <rect id="Rectangle-Copy-21" fill="#D4E1F4" x="460" y="60" width="1" height={this.state.height - 23}></rect>
                    <rect id="Rectangle-Copy-15" fill="#D4E1F4" x="552" y="60" width="1" height={this.state.height - 23}></rect>
                    <rect id="Rectangle-Copy-16" fill="#D4E1F4" x="644" y="60" width="1" height={this.state.height - 23}></rect>
                    <rect id="Rectangle-Copy-17" fill="#D4E1F4" x="736" y="60" width="1" height={this.state.height - 23}></rect>
                    <rect id="Rectangle-Copy-18" fill="#D4E1F4" x="828" y="60" width="1" height={this.state.height - 23}></rect>
                    <rect id="Rectangle-Copy-19" fill="#D4E1F4" x="920" y="60" width="1" height={this.state.height - 23}></rect>
                    <rect id="Rectangle-Copy-20" fill="#D4E1F4" x="1012" y="60" width="1" height={this.state.height - 23}></rect>
                  </g>

                  {/* agrego la descripción de las submedidas  */}
                  {this.props.subMedidasPlanesMovilidad.map((sm, k) => (
                    <text key={k} id="Sed-at-ipsum-Suspend" fontFamily="Catamaran" fontSize="14" fontWeight="500" fill="#787878">
                      <tspan x="110" y={835 + (70 * k)}>{this.getSplitDescription(sm.descripcion).first}</tspan>
                      <tspan x="110" y={855 + (70 * k)}>{this.getSplitDescription(sm.descripcion).second}</tspan>
                    </text>
                  ))}

                  {/* agrego la tarea en si */}
                  {this.props.subMedidasPlanesMovilidad.map((sm, k) => (
                    <g key={k} id="Group-0" transform={this.getSubMedidaInfo(sm, k, this.state.leftRange).translate}>
                      <rect id="Rectangle" fill={this.getSubMedidaInfo(sm, k, this.state.leftRange).color} x="0" y="0" width={this.getSubMedidaInfo(sm, k, this.state.leftRange).width} height="55"></rect>
                      {/* <text id={this.getSubMedidaInfo(sm, k).estado} fontFamily="Catamaran-Regular, Catamaran" fontSize="16" fontWeight="normal" fill="#FFFFFF">
                        <tspan x="16" y="30">{this.getSubMedidaInfo(sm, k, this.state.leftRange).estado}</tspan>
                      </text> */}
                    </g>
                  ))}

                  <g id="GroupHoy" transform={this.getToday(this.state.leftRange)}>
                    <rect id="Rectangle" fill="#00B2A9" x="34" y="0" width="2" height={this.state.height}></rect>
                    <rect id="Rectangle" fill="#00B2A9" x="0" y={this.state.height - 20} width="70" height="40" rx="20"></rect>
                    <text id="HOY" fontFamily="Catamaran" fontSize="14" fontWeight="bold" fill="#FFFFFF">
                      <tspan x="22" y={this.state.height +3}>HOY</tspan>
                    </text>
                  </g>

                </g>
              </g>
            </svg>
          </div>
        </div>
        <div className="PM-footer">&nbsp;</div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  idplanMovilidad: state.planMovilidad.idplanMovilidad,
  subMedidasPlanesMovilidad: state.planMovilidad.subMedidasPlanesMovilidad,
  isSubMedidasLoading: state.planMovilidad.isSubMedidasLoading,
  planMovilidad: state.planMovilidad,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(RoadMapSeguimientoPlanMovilidad);
